module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 1.871c3bed.png";